import { ItemCard } from './ItemCard.jsx';
import { EmptyState } from './EmptyState.jsx';

export function CategoryList({ categories, currency, layout, itemDisplay, onOpenItem, searchQuery = '' }) {
  if (categories.length === 0) {
    if (searchQuery.trim()) {
      return (
        <EmptyState
          title="No dishes match your search"
          description="Try a dish name, ingredient, or dietary note."
        />
      );
    }

    return (
      <EmptyState
        title="This menu doesn't have any items yet"
        description="Check back soon."
      />
    );
  }

  return (
    <>
      {categories.map((category, categoryIndex) => {
        const heroImageUrl = category.imageUrl;

        return (
          <section key={category.id} id={`category-${category.id}`} className="rm-category" aria-labelledby={`category-${category.id}-title`}>
            <div className="rm-category__hero">
              {heroImageUrl && (
                <img
                  className="rm-category__image"
                  src={heroImageUrl}
                  alt=""
                  role="presentation"
                  loading="lazy"
                  decoding="async"
                  onError={(event) => {
                    event.currentTarget.hidden = true;
                  }}
                />
              )}
              <p className="rm-category__eyebrow" aria-hidden="true">
                {categoryIndex === 0 ? 'Our signature dishes' : `Section ${String(categoryIndex + 1).padStart(2, '0')}`}
              </p>
              <div className="rm-category__heading">
                <span className="rm-category__flourish" aria-hidden="true" />
                <h2 id={`category-${category.id}-title`} className="rm-category__title">
                  {category.name}
                </h2>
                <span className="rm-category__flourish" aria-hidden="true" />
              </div>
              {category.description && <p className="rm-category__description">{category.description}</p>}
            </div>
            <div className={`rm-items--${layout.itemCardLayout}`}>
              {category.items.map((item) => (
                <ItemCard
                  key={item.id}
                  item={item}
                  currency={currency}
                  itemDisplay={itemDisplay}
                  onOpen={onOpenItem}
                />
              ))}
            </div>
          </section>
        );
      })}
    </>
  );
}
